import React from "react";
import "../Terms_of_Services/Terms_of_Services.css";
import "../../Homepage/LegalPageTheme.css";
import HeroNav from "../../Homepage/HeroNav";
import LegalLinks from "../../Homepage/LegalLinks";

const Privacy_Policy_DPDP = () => {
  return (
    <div className="TOS_Page">
      <HeroNav compact />

      <div className="TOS_Body">
        <h1 className="TOS_Title">
          PRIVACY POLICY &amp; DIGITAL PERSONAL DATA PROTECTION AGREEMENT
        </h1>
        <h2 className="TOS_Title1">Bolo-India-Media</h2>
        <br />
        <h3 className="TOS_Updated">Effective Date: 06-August-2026</h3>
        <h3 className="TOS_Updated">Last Updated: 06-August-2026</h3>
        <h3 className="TOS_Updated">Version: 1.0</h3>
        <br />

        <h2>1. INTRODUCTION</h2>
        <p>Welcome to Bolo-India-Media.</p>
        <p>
          Bolo-India-Media respects your privacy and is committed to
          protecting your personal data.
        </p>
        <p>
          This Privacy Policy and Digital Personal Data Protection Agreement
          (“Privacy Policy”) explains how Bolo-India-Media collects, uses,
          stores, shares, protects and otherwise processes personal data when
          you access or use the Bolo-India-Media mobile application, website,
          services, features and associated platforms (“Platform”).
        </p>
        <p>Bolo-India-Media is operated by:</p>
        <p>
          <strong>BOLO-INDIA MEDIA NETWORKS PRIVATE LIMITED</strong>
          <br />
          Registered Office: 122, C-WING, 3RD MAIN, GRUHALAKSHMI LAYOUT II
          STAGE, KAMALANAGAR, BANGALORE, KARNATAKA, INDIA.
          <br />
          Corporate Identification Number: U72900KA2022PTC161710
          <br />
          Email: <a href="mailto:namaste@boloindia.com">namaste@boloindia.com</a>
        </p>
        <p>
          For purposes of applicable data-protection law, BOLO-INDIA MEDIA
          NETWORKS PRIVATE LIMITED may act as the{" "}
          <strong>Data Fiduciary</strong> in relation to personal data for
          which it determines the purpose and means of processing.
        </p>
        <p>
          By using Bolo-India-Media, you acknowledge that you have been
          provided access to this Privacy Policy.
        </p>
        <p>
          Where consent is required for particular processing, Bolo-India-
          Media will seek such consent separately through an appropriate
          consent mechanism.
        </p>

        <h2>2. APPLICABLE DATA-PROTECTION FRAMEWORK</h2>
        <p>
          This Privacy Policy is intended to operate in accordance with
          applicable Indian law, including:
        </p>
        <ul>
          <li>the Digital Personal Data Protection Act, 2023 (“DPDP Act”);</li>
          <li>
            the Digital Personal Data Protection Rules, 2025 (“DPDP Rules”),
            according to their applicable commencement provisions;
          </li>
          <li>the Information Technology Act, 2000;</li>
          <li>applicable Information Technology Rules; and</li>
          <li>
            other applicable Indian privacy, cybersecurity and
            data-protection requirements.
          </li>
        </ul>
        <p>
          Where mandatory law provides greater protection than this Privacy
          Policy, the applicable law will prevail.
        </p>

        <h2>3. IMPORTANT DEFINITIONS</h2>
        <p>For purposes of this Privacy Policy:</p>
        <ul>
          <li>
            <strong>Personal Data</strong>
            <br />
            “Personal Data” means data about an individual who is
            identifiable by or in relation to such data.
          </li>
          <li>
            <strong>Data Principal</strong>
            <br />
            “Data Principal” means the individual to whom the personal data
            relates. Where applicable under the DPDP Act, this may include a
            parent/lawful guardian acting on behalf of a child or lawful
            guardian acting on behalf of a person with disability.
          </li>
          <li>
            <strong>Data Fiduciary</strong>
            <br />
            “Data Fiduciary” means a person who alone or together with others
            determines the purpose and means of processing personal data.
          </li>
          <li>
            <strong>Data Processor</strong>
            <br />A “Data Processor” processes personal data on behalf of a
            Data Fiduciary.
          </li>
          <li>
            <strong>Processing</strong>
            <br />
            Processing includes wholly or partly automated operations
            performed on digital personal data, including collection,
            recording, organisation, storage, adaptation, retrieval, use,
            sharing and erasure.
          </li>
        </ul>

        <h2>4. DATA FIDUCIARY</h2>
        <p>
          For personal data processed for purposes determined by
          Bolo-India-Media:
        </p>
        <p>
          <strong>Data Fiduciary:</strong> BOLO-INDIA MEDIA NETWORKS PRIVATE
          LIMITED
          <br />
          <strong>Registered Address:</strong> 122, C-WING, 3RD MAIN,
          GRUHALAKSHMI LAYOUT II STAGE, KAMALANAGAR, BANGALORE, KARNATAKA,
          INDIA.
          <br />
          <strong>Privacy Contact:</strong>{" "}
          <a href="mailto:privacy@boloindia.com">privacy@boloindia.com</a>
          <br />
          <strong>Grievance Contact:</strong>{" "}
          <a href="mailto:grievances@boloindia.com">
            grievances@boloindia.com
          </a>
        </p>

        <h2>5. PERSONAL DATA WE MAY COLLECT</h2>
        <p>
          The personal data we process depends upon the features you use and
          how you interact with Bolo-India.
        </p>
        <h2>5.1 Account Information</h2>
        <p>When you create an account, we may collect:</p>
        <ul>
          <li>name;</li>
          <li>username;</li>
          <li>mobile number;</li>
          <li>email address;</li>
          <li>date or year of birth;</li>
          <li>age;</li>
          <li>gender, where voluntarily provided and appropriate;</li>
          <li>profile photograph;</li>
          <li>language preference;</li>
          <li>password or authentication credentials;</li>
          <li>account settings; and</li>
          <li>other information necessary to create and secure your account.</li>
        </ul>

        <h2>6. PROFILE INFORMATION</h2>
        <p>You may choose to provide information such as:</p>
        <ul>
          <li>profile photograph;</li>
          <li>bio;</li>
          <li>interests;</li>
          <li>profession;</li>
          <li>city or general location;</li>
          <li>links;</li>
          <li>preferred languages; and</li>
          <li>other information you choose to display.</li>
        </ul>
        <p>
          You control certain profile visibility settings through the
          Platform. Information you intentionally make public may be visible
          to other users.
        </p>

        <h2>7. USER CONTENT</h2>
        <p>
          We process content you create, upload, publish or share through
          Bolo-India-Media. This may include:
        </p>
        <ul>
          <li>posts;</li>
          <li>comments;</li>
          <li>photographs;</li>
          <li>videos;</li>
          <li>short videos;</li>
          <li>long-form videos;</li>
          <li>livestreams;</li>
          <li>audio;</li>
          <li>music;</li>
          <li>stories;</li>
          <li>reactions;</li>
          <li>captions;</li>
          <li>hashtags;</li>
          <li>polls; and</li>
          <li>other user-generated content.</li>
        </ul>
        <p>
          Content you publish publicly may be visible to other users and
          potentially outside Bolo-India-Media where sharing functionality
          permits.
        </p>

        <h2>8. SOCIAL GRAPH AND INTERACTIONS</h2>
        <p>
          We may process information concerning how you interact with
          Bolo-India-Media, including:
        </p>
        <ul>
          <li>accounts you follow;</li>
          <li>followers;</li>
          <li>likes/reactions;</li>
          <li>comments;</li>
          <li>shares;</li>
          <li>reposts;</li>
          <li>saves;</li>
          <li>content viewed;</li>
          <li>watch time;</li>
          <li>searches;</li>
          <li>groups or communities joined;</li>
          <li>creator interactions; and</li>
          <li>other engagement activity.</li>
        </ul>
        <p>
          This information helps us operate social and content-discovery
          features.
        </p>

        <h2>9. COMMUNICATION DATA</h2>
        <p>
          Where Bolo-India-Media provides messaging or communication
          features, we may process information necessary to deliver and
          secure those communications. This may include:
        </p>
        <ul>
          <li>sender and recipient identifiers;</li>
          <li>timestamps;</li>
          <li>delivery information;</li>
          <li>abuse reports;</li>
          <li>spam signals; and</li>
          <li>
            message content where processing is necessary and legally
            permitted for the operation, safety or moderation of the service.
          </li>
        </ul>
        <p>
          The precise treatment of private communications may depend upon the
          messaging architecture used by Bolo-India-Media.
        </p>

        <h2>10. DEVICE AND TECHNICAL INFORMATION</h2>
        <p>
          When you access Bolo-India-Media, we may automatically receive
          technical information such as:
        </p>
        <ul>
          <li>IP address;</li>
          <li>device type;</li>
          <li>device model;</li>
          <li>operating system;</li>
          <li>application version;</li>
          <li>browser type;</li>
          <li>language;</li>
          <li>network information;</li>
          <li>device identifiers;</li>
          <li>crash information;</li>
          <li>security information; and</li>
          <li>diagnostic logs.</li>
        </ul>
        <p>
          We use this information for Platform operation, security,
          troubleshooting, analytics and fraud prevention.
        </p>

        <h2>11. LOCATION INFORMATION</h2>
        <p>
          Bolo-India-Media may process approximate location information
          derived from information such as your IP address.
        </p>
        <p>
          Where a feature requires more precise location information, we will
          request appropriate device permission and, where required, consent.
        </p>
        <p>
          You may be able to disable location permissions through your device
          settings. Some location-dependent features may then become
          unavailable.
        </p>

        <h2>12. CONTACTS</h2>
        <p>
          If Bolo-India-Media offers a “Invite Friends” or contact-discovery
          feature, access to your contacts will be optional and subject to
          appropriate device permissions and applicable consent requirements.
        </p>
        <p>
          Where technically feasible and appropriate, Bolo-India-Media may
          use privacy-preserving matching techniques instead of permanently
          storing complete address books.
        </p>
        <p>
          Users should be able to decline contact syncing without losing
          unrelated core Platform functionality.
        </p>

        <h2>13. CAMERA AND MICROPHONE</h2>
        <p>
          Bolo-India-Media may request access to your camera and microphone
          when you choose to:
        </p>
        <ul>
          <li>capture photographs;</li>
          <li>record videos;</li>
          <li>create short videos;</li>
          <li>livestream;</li>
          <li>record audio;</li>
          <li>participate in calls; or</li>
          <li>use other media features.</li>
        </ul>
        <p>
          Camera and microphone permissions may be controlled through your
          device settings.
        </p>

        <h2>14. PHOTOS AND MEDIA</h2>
        <p>
          Bolo-India-Media may request access to selected photographs, videos
          or media files when you choose to upload content.
        </p>
        <p>
          Where supported by the operating system, we may offer limited or
          selected-media access rather than requiring access to your entire
          media library.
        </p>

        <h2>15. INFORMATION FROM THIRD PARTIES</h2>
        <p>
          Where you choose to use third-party login or integrated services,
          Bolo-India-Media may receive information authorised by you and the
          relevant third-party service.
        </p>
        <p>
          The categories of information received will depend on the
          permissions you grant.
        </p>

        <h2>16. WHY WE PROCESS PERSONAL DATA</h2>
        <p>
          Bolo-India-Media processes personal data only for lawful purposes
          and on grounds permitted under applicable law. Depending upon the
          feature and circumstances, processing may be based on:
        </p>
        <p>
          <strong>Your Consent</strong>
          <br />
          Where you have given valid consent for a specified purpose.
        </p>
        <p>
          <strong>Certain Legitimate Uses</strong>
          <br />
          Where processing is permitted under the DPDP Act without separate
          consent in circumstances recognised by law.
        </p>
        <p>
          <strong>Legal Obligations</strong>
          <br />
          Where processing is necessary to comply with applicable law, court
          orders or legally valid governmental requirements.
        </p>

        <h2>17. PURPOSES OF PROCESSING</h2>
        <p>We may process personal data to:</p>
        <p>
          <strong>Provide Bolo-India-Media</strong>
        </p>
        <ul>
          <li>create accounts;</li>
          <li>authenticate users;</li>
          <li>maintain profiles;</li>
          <li>publish content;</li>
          <li>deliver feeds;</li>
          <li>enable comments and reactions;</li>
          <li>deliver messages;</li>
          <li>operate livestreaming;</li>
          <li>enable sharing;</li>
          <li>provide search;</li>
          <li>provide creator functionality.</li>
        </ul>
        <p>
          <strong>Personalise Your Experience</strong>
        </p>
        <p>
          We may use information about your activity to determine content
          that may be relevant to you. This can include signals such as:
        </p>
        <ul>
          <li>accounts followed;</li>
          <li>content viewed;</li>
          <li>engagement;</li>
          <li>language;</li>
          <li>interests;</li>
          <li>searches;</li>
          <li>watch time; and</li>
          <li>content interactions.</li>
        </ul>
        <p>
          <strong>To Keep Bolo-India-Media Safe</strong>
        </p>
        <p>We may process information to:</p>
        <ul>
          <li>detect spam;</li>
          <li>detect fraud;</li>
          <li>prevent account theft;</li>
          <li>identify fake accounts;</li>
          <li>detect malicious activity;</li>
          <li>investigate harassment;</li>
          <li>protect children;</li>
          <li>enforce Community Guidelines;</li>
          <li>detect copyright infringement;</li>
          <li>identify prohibited AI/deepfake content; and</li>
          <li>protect Platform security.</li>
        </ul>
        <p>
          <strong>Improve Bolo-India-Media</strong>
        </p>
        <p>
          We may analyse aggregated or appropriately processed information to
          understand Platform performance and improve products and features.
        </p>

        <h2>18. CONSENT</h2>
        <p>
          Where consent is the applicable basis for processing, Bolo-India-
          Media will request consent in accordance with applicable law.
        </p>
        <p>
          Consent will be sought through clear affirmative action and will
          relate to specified purposes.
        </p>
        <p>
          We will not treat inactivity, silence or pre-selected options as
          consent where affirmative consent is legally required.
        </p>

        <h2>19. GRANULAR CONSENT</h2>
        <p>
          Where appropriate, Bolo-India-Media will seek separate permissions
          or choices for materially different processing activities. For
          example:
        </p>
        <p>
          <strong>Required for Account</strong>
        </p>
        <ul>
          <li>Mobile/email authentication</li>
          <li>Account security</li>
          <li>Core Platform operation</li>
        </ul>
        <p>
          <strong>Optional</strong>
        </p>
        <ul>
          <li>Contact syncing</li>
          <li>Precise location</li>
          <li>Personalised marketing communications</li>
          <li>Optional device permissions</li>
          <li>Other optional features</li>
        </ul>
        <p>
          Refusing optional consent will not prevent access to unrelated core
          features unless the processing is genuinely necessary to provide
          the requested feature.
        </p>

        <h2>20. WITHDRAWING CONSENT</h2>
        <p>
          Where processing is based on consent, you may withdraw that consent
          using a mechanism that is reasonably comparable in ease to the
          mechanism through which consent was given.
        </p>
        <p>You may be able to do this through:</p>
        <p>
          <strong>Settings → Privacy → Permissions &amp; Consent</strong>
          <br />
          or by contacting:{" "}
          <a href="mailto:privacy@boloindia.com">privacy@boloindia.com</a>
        </p>
        <p>Withdrawal will apply prospectively.</p>
        <p>
          Certain features may stop working if the personal data is necessary
          to provide those features.
        </p>

        <h2>21. CONSENT RECORDS</h2>
        <p>Bolo-India-Media may maintain records demonstrating:</p>
        <ul>
          <li>the notice shown;</li>
          <li>consent requested;</li>
          <li>purpose;</li>
          <li>date/time;</li>
          <li>consent action;</li>
          <li>policy/version presented;</li>
          <li>withdrawal; and</li>
          <li>changes to consent.</li>
        </ul>
        <p>
          These records help demonstrate compliance with applicable law.
        </p>

        <h2>22. PRIVACY NOTICE</h2>
        <p>
          When Bolo-India-Media requests consent for processing personal
          data, the relevant notice will identify or make accessible
          information concerning:
        </p>
        <ul>
          <li>personal data proposed to be processed;</li>
          <li>purpose of processing;</li>
          <li>relevant rights;</li>
          <li>mechanism to withdraw consent;</li>
          <li>grievance mechanism; and</li>
          <li>
            mechanism for making a complaint to the Data Protection Board of
            India, where applicable.
          </li>
        </ul>
        <p>
          The notice will be presented in clear and understandable language
          as required by applicable law.
        </p>

        <h2>23. LANGUAGE ACCESSIBILITY</h2>
        <p>
          Where required under applicable law, users will be provided the
          option to access applicable DPDP notices in English.
        </p>
        <p>
          Bolo-India-Media may progressively support privacy information in
          multiple Indian languages.
        </p>

        <h2>24. CHILDREN</h2>
        <p>
          Under the DPDP framework, a person below eighteen years of age is
          generally treated as a child, subject to exemptions or
          modifications that may be notified under applicable law.
        </p>
        <p>
          Bolo-India-Media will implement appropriate age-assurance and
          child-data safeguards.
        </p>

        <h2>25. VERIFIABLE PARENTAL CONSENT</h2>
        <p>
          Where applicable, Bolo-India-Media will obtain verifiable consent
          from a parent or lawful guardian before processing a child's
          personal data.
        </p>
        <p>
          Bolo-India-Media may implement mechanisms permitted under
          applicable DPDP requirements for verifying that the person
          providing parental consent is an adult and is identifiable where
          legally required.
        </p>
        <p>
          The mechanism may involve appropriate age/identity information or
          authorised verification/token mechanisms permitted by law.
        </p>

        <h2>26. CHILDREN'S PRIVACY</h2>
        <p>
          Subject to applicable exemptions, Bolo-India-Media will not
          undertake prohibited:
        </p>
        <ul>
          <li>tracking of children;</li>
          <li>behavioural monitoring of children; or</li>
          <li>targeted advertising directed at children.</li>
        </ul>
        <p>
          Bolo-India-Media will not knowingly undertake processing likely to
          cause detrimental effects on the well-being of a child.
        </p>
        <p>Additional child-safety settings may include:</p>
        <ul>
          <li>private-by-default profiles;</li>
          <li>messaging restrictions;</li>
          <li>recommendation safeguards;</li>
          <li>livestream restrictions;</li>
          <li>location restrictions;</li>
          <li>contact restrictions; and</li>
          <li>parental controls.</li>
        </ul>

        <h2>27. PARENT/GUARDIAN REQUESTS</h2>
        <p>
          A parent or lawful guardian may contact Bolo-India-Media regarding a
          child's account through:
        </p>
        <p>
          <strong>Child Privacy Contact:</strong>{" "}
          <a href="mailto:privacy@boloindia.com">privacy@boloindia.com</a>
        </p>
        <p>
          Bolo-India-Media may verify the identity and authority of the
          requesting person before acting upon a request.
        </p>

        <h2>28. PERSONALISED RECOMMENDATIONS</h2>
        <p>Bolo-India-Media may use information such as:</p>
        <ul>
          <li>content viewed;</li>
          <li>accounts followed;</li>
          <li>language;</li>
          <li>interactions;</li>
          <li>watch time;</li>
          <li>searches; and</li>
          <li>engagement</li>
        </ul>
        <p>to rank or recommend content.</p>
        <p>Where legally required, appropriate consent or controls will be provided.</p>
        <p>
          Recommendation systems may also use non-personal or contextual
          signals.
        </p>

        <h2>29. ADVERTISING</h2>
        <p>
          Bolo-India-Media may display advertisements and sponsored content.
          Advertising may be based on contextual information such as:
        </p>
        <ul>
          <li>content being viewed;</li>
          <li>language;</li>
          <li>broad location;</li>
          <li>Platform section; or</li>
          <li>other non-personal/contextual factors.</li>
        </ul>
        <p>
          Where personalised advertising requires consent or another lawful
          basis, Bolo-India-Media will implement the appropriate mechanism.
        </p>
        <p>
          Bolo-India-Media will not undertake targeted advertising directed
          at children where prohibited by applicable law.
        </p>

        <h2>30. MARKETING COMMUNICATIONS</h2>
        <p>
          Bolo-India-Media may send service communications necessary to
          operate your account.
        </p>
        <p>Optional promotional communications may be controlled separately.</p>
        <p>Where required, you may withdraw marketing preferences through:</p>
        <p>
          <strong>Settings → Notifications</strong> or by using the
          unsubscribe mechanism provided.
        </p>

        <h2>31. DATA PROCESSORS</h2>
        <p>
          Bolo-India-Media may engage service providers to process personal
          data on its behalf. These may include providers of:
        </p>
        <ul>
          <li>cloud infrastructure;</li>
          <li>content delivery;</li>
          <li>security;</li>
          <li>communications;</li>
          <li>customer support;</li>
          <li>analytics;</li>
          <li>fraud detection;</li>
          <li>content moderation;</li>
          <li>payment services; and</li>
          <li>other technology services.</li>
        </ul>
        <p>
          Bolo-India-Media will use Data Processors under appropriate
          contractual arrangements as required by applicable law.
        </p>

        <h2>32. SHARING OF PERSONAL DATA</h2>
        <p>Bolo-India-Media may share personal data where reasonably necessary with:</p>
        <p>
          <strong>Service Providers</strong>
          <br />
          Companies processing information on our behalf.
        </p>
        <p>
          <strong>Other Users</strong>
          <br />
          Information you choose to publish publicly or share with specified
          audiences.
        </p>
        <p>
          <strong>Business Partners</strong>
          <br />
          Where necessary for a feature and legally permitted.
        </p>
        <p>
          <strong>Authorities</strong>
          <br />
          Where disclosure is required pursuant to applicable law or legally
          valid process.
        </p>
        <p>
          <strong>Corporate Transactions</strong>
          <br />
          In connection with a merger, acquisition, restructuring or transfer
          of business, subject to applicable law and appropriate safeguards.
        </p>
        <p>
          Bolo-India-Media does not sell personal data merely by virtue of
          providing the Platform.
        </p>

        <h2>33. PUBLIC INFORMATION</h2>
        <p>
          Information you choose to publish publicly may be viewed, shared or
          copied by others. Examples include:
        </p>
        <ul>
          <li>public profile information;</li>
          <li>public posts;</li>
          <li>public videos;</li>
          <li>comments;</li>
          <li>public follower/following information; and</li>
          <li>other content designated public.</li>
        </ul>
        <p>
          You should avoid posting information publicly that you do not want
          others to see.
        </p>

        <h2>34. DATA SECURITY</h2>
        <p>
          Bolo-India-Media will implement reasonable technical and
          organisational measures designed to protect personal data.
          Depending upon the nature and risk of processing, measures may
          include:
        </p>
        <ul>
          <li>encryption;</li>
          <li>access controls;</li>
          <li>authentication;</li>
          <li>secure password handling;</li>
          <li>network security;</li>
          <li>logging;</li>
          <li>monitoring;</li>
          <li>vulnerability management;</li>
          <li>backup controls;</li>
          <li>incident response;</li>
          <li>role-based employee access;</li>
          <li>processor security requirements; and</li>
          <li>periodic security reviews.</li>
        </ul>
        <p>No online service can guarantee absolute security.</p>

        <h2>35. ACCESS CONTROL</h2>
        <p>
          Access to personal data by Bolo-India-Media personnel will be
          limited according to legitimate business need.
        </p>
        <p>Administrative access should be:</p>
        <ul>
          <li>role-based;</li>
          <li>logged;</li>
          <li>monitored;</li>
          <li>revocable; and</li>
          <li>periodically reviewed.</li>
        </ul>
        <p>
          Employees and contractors may be subject to confidentiality and
          data-protection obligations.
        </p>

        <h2>36. PERSONAL DATA BREACH</h2>
        <p>
          A “personal data breach” may include unauthorised processing or
          accidental disclosure, acquisition, sharing, use, alteration,
          destruction or loss of access to personal data that compromises its
          confidentiality, integrity or availability.
        </p>
        <p>
          Bolo-India-Media will maintain an incident-response process
          designed to:
        </p>
        <ul>
          <li>detect incidents;</li>
          <li>contain them;</li>
          <li>investigate them;</li>
          <li>assess affected data;</li>
          <li>mitigate harm;</li>
          <li>preserve relevant evidence;</li>
          <li>remediate vulnerabilities; and</li>
          <li>make notifications required under applicable law.</li>
        </ul>

        <h2>37. BREACH NOTIFICATION</h2>
        <p>
          Where required under applicable DPDP provisions, Bolo-India-Media
          will notify affected Data Principals and the Data Protection Board
          of India in the prescribed form and manner.
        </p>
        <p>
          Notifications may include appropriate information regarding the
          nature of the breach and measures users can take to protect
          themselves.
        </p>

        <h2>38. DATA RETENTION</h2>
        <p>
          Bolo-India-Media will not retain personal data indefinitely merely
          because it may be useful in the future.
        </p>
        <p>Subject to applicable law, personal data will be retained for periods necessary to:</p>
        <ul>
          <li>provide the Platform;</li>
          <li>fulfil the specified purpose;</li>
          <li>comply with legal requirements;</li>
          <li>maintain security;</li>
          <li>prevent fraud;</li>
          <li>resolve disputes; or</li>
          <li>establish, exercise or defend legal claims.</li>
        </ul>
        <p>
          When the applicable purpose is no longer served and retention is
          not otherwise required by law, personal data will be erased in
          accordance with applicable DPDP requirements.
        </p>

        <h2>39. ACCOUNT INACTIVITY</h2>
        <p>
          Where prescribed retention rules apply to a class of users or
          services, Bolo-India-Media may erase applicable personal data
          following the prescribed period of inactivity after providing
          required advance notice.
        </p>
        <p>
          Specific retention periods may therefore change to reflect
          applicable DPDP Rules and other legal requirements.
        </p>

        <h2>40. ACCOUNT DELETION</h2>
        <p>You may request deletion of your Bolo-India-Media account through:</p>
        <p>
          <strong>Settings → Account → Delete Account</strong>
        </p>
        <p>
          Bolo-India-Media may provide an appropriate confirmation or
          cooling-off period before permanent deletion.
        </p>
        <p>
          Following completion of deletion, personal data associated with the
          account will be erased or anonymised as required, subject to
          lawful retention requirements.
        </p>

        <h2>41. DATA AFTER ACCOUNT DELETION</h2>
        <p>Certain information may be retained where necessary for:</p>
        <ul>
          <li>compliance with law;</li>
          <li>court orders;</li>
          <li>fraud prevention;</li>
          <li>security investigations;</li>
          <li>grievance handling;</li>
          <li>copyright disputes;</li>
          <li>regulatory requirements;</li>
          <li>legal claims; or</li>
          <li>other legally permitted purposes.</li>
        </ul>
        <p>
          Information may also temporarily remain in secure backup systems
          until deletion cycles are completed.
        </p>

        <h2>42. YOUR DPDP RIGHTS</h2>
        <p>
          Subject to applicable law and commencement provisions, Data
          Principals may exercise rights including:
        </p>
        <p>
          <strong>Access to Information</strong>
          <br />
          You may request applicable information concerning personal data
          being processed and processing activities.
        </p>
        <p>
          <strong>Correction</strong>
          <br />
          You may request correction of inaccurate or misleading personal
          data.
        </p>
        <p>
          <strong>Completion</strong>
          <br />
          You may request completion of incomplete personal data.
        </p>
        <p>
          <strong>Updating</strong>
          <br />
          You may request updating of personal data.
        </p>
        <p>
          <strong>Erasure</strong>
          <br />
          You may request erasure of personal data where the applicable legal
          requirements are satisfied.
        </p>
        <p>
          <strong>Grievance Redressal</strong>
          <br />
          You may raise grievances concerning Bolo-India-Media's processing
          of your personal data.
        </p>
        <p>
          <strong>Nomination</strong>
          <br />
          You may nominate another individual to exercise applicable rights
          in the event of death or incapacity, subject to applicable law.
        </p>

        <h2>43. EXERCISING YOUR RIGHTS</h2>
        <p>Where available, rights may be exercised through:</p>
        <p>
          <a href="mailto:privacy@boloindia.com">privacy@boloindia.com</a>
        </p>
        <p>
          Bolo-India-Media may require reasonable authentication before
          fulfilling a request to protect users against fraudulent requests.
        </p>

        <h2>44. ACCESS REQUESTS</h2>
        <p>
          Where applicable, a Data Principal may request information
          prescribed under the DPDP framework regarding personal data
          processing.
        </p>
        <p>Bolo-India-Media will respond according to applicable legal requirements.</p>
        <p>Information may be withheld where an applicable statutory exemption applies.</p>

        <h2>45. CORRECTION AND ERASURE</h2>
        <p>Users may directly edit certain profile information through account settings.</p>
        <p>
          For information that cannot be directly edited, users may submit a
          correction request.
        </p>
        <p>
          Bolo-India-Media will correct, complete, update or erase personal
          data as required under applicable law.
        </p>

        <h2>46. GRIEVANCE REDRESSAL</h2>
        <p>
          If you have a concern regarding how Bolo-India-Media processes your
          personal data, please contact:
        </p>
        <p>
          <strong>Privacy Grievance Contact</strong>
          <br />
          Email:{" "}
          <a href="mailto:privacy@boloindia.com">privacy@boloindia.com</a>
        </p>
        <p>
          Bolo-India-Media will maintain an effective mechanism for handling
          Data Principal grievances and will respond within timelines
          required under applicable law.
        </p>

        <h2>47. DUTIES OF USERS AS DATA PRINCIPALS</h2>
        <p>Users must comply with duties imposed by applicable law.</p>
        <p>Among other things, users should not:</p>
        <ul>
          <li>impersonate another person while providing personal data;</li>
          <li>suppress material information where legally relevant;</li>
          <li>submit false or frivolous grievances; or</li>
          <li>provide false information while exercising statutory rights.</li>
        </ul>

        <h2>48. CROSS-BORDER PROCESSING</h2>
        <p>Bolo-India-Media may use infrastructure or service providers located outside India.</p>
        <p>
          Personal data may therefore be processed outside India where
          permitted under applicable law.
        </p>
        <p>
          Bolo-India-Media will comply with restrictions that may be
          notified by the Central Government concerning transfer of personal
          data outside India.
        </p>
        <p>
          Where another applicable Indian law imposes a specific
          localisation requirement, Bolo-India-Media will comply with that
          requirement.
        </p>

        <h2>49. DATA MINIMISATION</h2>
        <p>
          Bolo-India-Media will seek to collect and process personal data
          appropriate to the specified purpose.
        </p>
        <p>
          Optional features should not require unrelated personal data
          merely because the information may have potential commercial
          value.
        </p>

        <h2>50. PURPOSE LIMITATION</h2>
        <p>
          Personal data collected for a specified purpose should not be
          repurposed in a manner inconsistent with applicable DPDP
          requirements without an appropriate legal basis and, where
          required, fresh notice and consent.
        </p>

        <h2>51. ACCURACY</h2>
        <p>
          Where personal data is used to make decisions affecting a Data
          Principal or is disclosed to another Data Fiduciary in
          circumstances covered by applicable law, Bolo-India-Media will
          take appropriate steps regarding completeness, accuracy and
          consistency.
        </p>
        <p>Users should keep their account information current.</p>

        <h2>52. AUTOMATED SYSTEMS AND AI</h2>
        <p>Bolo-India-Media may use automated systems and artificial intelligence for:</p>
        <ul>
          <li>content recommendation;</li>
          <li>spam detection;</li>
          <li>fraud detection;</li>
          <li>account security;</li>
          <li>content moderation;</li>
          <li>search;</li>
          <li>translation;</li>
          <li>captioning;</li>
          <li>abuse detection; and</li>
          <li>Platform improvement.</li>
        </ul>
        <p>
          Personal data used by such systems remains subject to applicable
          privacy and security requirements.
        </p>
        <p>
          Where a new AI system creates material privacy risk, Bolo-India-
          Media may conduct an appropriate privacy assessment before
          deployment.
        </p>

        <h2>53. ANALYTICS</h2>
        <p>Bolo-India-Media may use analytics to understand:</p>
        <ul>
          <li>active users;</li>
          <li>Platform performance;</li>
          <li>content engagement;</li>
          <li>crashes;</li>
          <li>feature usage;</li>
          <li>user journeys; and</li>
          <li>aggregate trends.</li>
        </ul>
        <p>
          Where reasonably possible, aggregated, de-identified or
          privacy-preserving information may be used for analytics.
        </p>

        <h2>54. COOKIES, SDKs AND SIMILAR TECHNOLOGIES</h2>
        <p>Bolo-India-Media's website and app may use:</p>
        <ul>
          <li>cookies;</li>
          <li>software development kits (SDKs);</li>
          <li>local storage;</li>
          <li>pixels;</li>
          <li>device identifiers; and</li>
          <li>similar technologies.</li>
        </ul>
        <p>These may be used for:</p>
        <ul>
          <li>authentication;</li>
          <li>security;</li>
          <li>user preferences;</li>
          <li>analytics;</li>
          <li>performance;</li>
          <li>advertising; and</li>
          <li>fraud prevention.</li>
        </ul>
        <p>Appropriate consent or choice mechanisms will be provided where required.</p>

        <h2>55. THIRD-PARTY LINKS</h2>
        <p>Bolo-India-Media may contain links to third-party websites or services.</p>
        <p>
          Bolo-India-Media is not responsible for independent privacy
          practices of third parties merely because their services are
          linked from the Platform.
        </p>
        <p>Users should review the privacy policies of those services.</p>

        <h2>56. CHANGES TO THIS PRIVACY POLICY</h2>
        <p>We may update this Privacy Policy to reflect:</p>
        <ul>
          <li>changes to Bolo-India-Media;</li>
          <li>new features;</li>
          <li>changes in law;</li>
          <li>changes to the DPDP Rules;</li>
          <li>regulatory requirements;</li>
          <li>security developments; or</li>
          <li>changes in our processing activities.</li>
        </ul>
        <p>Where required, we will provide notice of material changes.</p>
        <p>Where a change requires fresh consent, we will request that consent separately.</p>

        <h2>57. CONTACT BOLO-INDIA-MEDIA</h2>
        <p>
          <strong>Privacy Contact:</strong>
          <br />
          Email:{" "}
          <a href="mailto:privacy@boloindia.com">privacy@boloindia.com</a>
        </p>
        <p>
          <strong>Grievance Officer</strong>
          <br />
          Email:{" "}
          <a href="mailto:grievance@boloindia.com">grievance@boloindia.com</a>
        </p>
        <p>
          <strong>Registered Office: BOLO-INDIA MEDIA NETWORKS PRIVATE LIMITED</strong>
          <br />
          Registered Office: 122, C-WING, 3RD MAIN, GRUHALAKSHMI LAYOUT II
          STAGE, KAMALANAGAR, BANGALORE, KARNATAKA, INDIA.
        </p>

        <h2>58. USER PRIVACY DASHBOARD</h2>
        <p>
          <strong>Settings → Privacy</strong>
        </p>

        <h2>59. PRIVACY COMMITMENT</h2>
        <p>
          Bolo-India-Media is built around people's voices. Protecting those
          voices also means protecting the information behind them.
        </p>
        <p>
          Our objective is to give users meaningful control over their
          personal data while providing a safe, useful and engaging social
          platform.
        </p>
        <p>We therefore seek to follow four simple principles:</p>
        <ul>
          <li>Collect what we need.</li>
          <li>Explain why we need it.</li>
          <li>Protect what you give us.</li>
          <li>Give you meaningful control over your data.</li>
          <li>Your Voice. Your Data. Your Choice.</li>
        </ul>
        <p>
          <strong>Bolo-India-Media.</strong>
        </p>
      </div>

      <LegalLinks />
    </div>
  );
};

export default Privacy_Policy_DPDP;
